module.exports = __webpack_public_path__ + "img/rs.rs9f00a7d.svg";